/**
 * This reducer accepts the data from action and updates the state in store with new state.
 * */

import {
  GET_FACULTIES,
  SET_FACULTY,
  GET_SEMESTERS,
  SET_SEMESTER,
  GET_COURSES,
  SET_COURSE,
  GET_LECTURES,
  SET_LECTURE,
  GET_STUDY_SEMESTERS,
  SET_STUDY_SEMESTER,
  GET_DESIGN_FACULTY_DATA,
  SET_DESIGN_FACULTY_SEGMENTS,
  SET_DESIGN_FACULTY_SEGMENT,
  RESET_SELECTION,
  TOGGLE_LOADING,
  SET_CACHE_STATUS,
} from '../actions/types'
import {
  CACHED_HOME,
  DEFAULT_LANGUAGE,
  FACULTY_DESIGN_ID,
  RESET_ALL,
  RESET_COURSE,
  RESET_LECTURE,
  RESET_SEMESTER,
  RESET_STUDY_SEMESTER,
  RESET_FACULTY_DESIGN_DATA,
  RESET_FACULTY_DESIGN_SEGMENT,
} from '../config'

const initialState = {
  faculties: [],
  faculty: null,
  semesters: [],
  semester: null,
  courses: [],
  course: null,
  lectures: [],
  lecture: null,
  study_semesters: [],
  study_semester: '',
  faculty_design: false,
  faculty_design_data: {},
  faculty_design_segments: [],
  faculty_design_segment: {},
  loading: true,
  language: DEFAULT_LANGUAGE,
  cache_status: CACHED_HOME,
}


const vvz = function (state = initialState, action) {
  switch (action.type) {
    case GET_FACULTIES:
      return {
        ...state,
        loading: false,
        faculties: action.payload,
      }
    case SET_FACULTY:
      return {
        ...state,
        loading: false,
        faculty: action.payload,
        faculty_design: action.payload?.id && FACULTY_DESIGN_ID === parseInt(action.payload?.id, 10),
        faculty_flex: action.payload?.id === 'FLEX',
      }
    case GET_SEMESTERS:
      return {
        ...state,
        loading: false,
        semesters: action.payload,
      }
    case SET_SEMESTER:
      return {
        ...state,
        loading: true,
        semester: action.payload,
      }
    case GET_COURSES:
      return {
        ...state,
        loading: true,
        courses: action.payload,
      }
    case SET_COURSE:
      return {
        ...state,
        loading: true,
        course: action.payload,
      }
    case GET_LECTURES:
      return {
        ...state,
        loading: true,
        lectures: action.payload,
      }
    case SET_LECTURE:
      return {
        ...state,
        loading: false,
        lecture: action.payload,
      }
    case GET_STUDY_SEMESTERS:
      return {
        ...state,
        loading: true,
        study_semesters: action.payload,
      }
    case SET_STUDY_SEMESTER:
      return {
        ...state,
        loading: true,
        study_semester: action.payload,
      }
    case GET_DESIGN_FACULTY_DATA:
      return {
        ...state,
        loading: true,
        faculty_design: true,
        faculty_design_data: action.payload,
      }
    case SET_DESIGN_FACULTY_SEGMENTS:
      return {
        ...state,
        faculty_design_segments: action.payload,
      }
    case SET_DESIGN_FACULTY_SEGMENT:
      return {
        ...state,
        faculty_design_segment: action.payload,
      }
    case RESET_SELECTION:
      const _reset_defaults = {}

      const _reset_all = {
        faculty: null,
        courses: [],
        semester: null,
        course: null,
        study_semesters: [],
        study_semester: '',
        faculty_design: false,
        faculty_design_data: {},
        faculty_design_segments: [],
        faculty_design_segment: {},
        loading: false,
      }

      // Resets only semester and the data depending on it
      const _reset_semester = {
        semester: null,
        study_semesters: [],
        study_semester: '',
      }

      const _reset_course = {
        course: null,
      }

      const _reset_study_semester = {
        study_semester: '',
      }

      const _reset_lecture = {
        lecture: null,
      }

      const _reset_design_faculty_data = {
        faculty_design: false,
        faculty_design_data: {},
      }

      const _reset_design_faculty_segment = {
        faculty_design_segment: {}
      }

      switch(action.payload) {
        case RESET_ALL:
          return {
            ...state,
            ..._reset_defaults,
            ..._reset_all,
            ..._reset_lecture,
          }
        case RESET_LECTURE:
          return {
            ...state,
            ..._reset_defaults,
            ..._reset_lecture,
          }
        case RESET_SEMESTER:
          return {
            ...state,
            ..._reset_defaults,
            ..._reset_semester,
            ..._reset_course,
          }
        case RESET_COURSE:
          return {
            ...state,
            ..._reset_defaults,
            ..._reset_course,
          }
        case RESET_STUDY_SEMESTER:
          return {
            ...state,
            ..._reset_defaults,
            ..._reset_study_semester,
          }
        case RESET_FACULTY_DESIGN_DATA:
          return {
            ...state,
            ..._reset_design_faculty_data,
          }
        case RESET_FACULTY_DESIGN_SEGMENT:
          return {
            ...state,
            ..._reset_design_faculty_segment,
          }
        default:
          return state
      }
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SET_CACHE_STATUS:
      return {
        ...state,
        cache_status: action.payload,
      }
    default:
      return state
  }
}

export default vvz
